(function($) {
    function initMostPopularLoadMore(container) {
        let loadMoreContainer = container.find('.js-most-popular-load-more');
        loadMoreContainer.find('.js-most-popular-load-more-link').on('click', function (e) {
            loadMoreContainer.addClass('d-none');
            container.find('.js-most-popular-item').removeClass('d-none');
            e.preventDefault();
        });
    }

    function init(container) {
        initMostPopularLoadMore(container);
    }

    $(document).ready(function() {
        $('.js-neocenter-landing-page').each(function(index, container) {
            init($(container));
        });
    });
})(jQuery);
